import gql from 'graphql-tag';

const SWITCH_WINDOW = gql`
    mutation switchWindow($input: SwitchWindowInput) {
        switchWindow(input: $input) {
            internalCode
        }
    }
`;

export default SWITCH_WINDOW;
